import React, { PropTypes, Component } from 'react'
import { connect } from 'react-redux'

// Styles
import classes from './AdminCompany.scss'

// Actions
import { companyActions } from 'redux/actionCreators'

// Components
import { Heading, Searchbox, Pagination } from 'components'

// Helpers
import { hasChanged } from 'helpers/utilities'
import _get from 'lodash.get'
import _omitBy from 'lodash.omitby'
import _isNil from 'lodash.isnil'

const mapStateToProps = (state) => ({
  companies: _get(state, ['company', 'companies']) || [],
  pageCount: _get(state, ['company', 'pageCount']) || 0
})
const mapDispatchToProps = (dispatch) => ({
  attemptFindCompanies: (payload) =>
    dispatch(companyActions.attemptFindCompanies(payload)),
  setInitial: () => dispatch({ type: 'SET_INITIAL' })
})

@connect(mapStateToProps, mapDispatchToProps)
class AdminCompanies extends Component {
  static propTypes = {
    companies: PropTypes.array.isRequired,
    attemptFindCompanies: PropTypes.func.isRequired
  };

  static contextTypes = { router: PropTypes.object.isRequired };

  componentWillMount () {
    this._findCompanies(this.props)
  }

  componentWillReceiveProps (nextProps) {
    if (hasChanged(this.props, nextProps, ['location', 'query'])) {
      this._findCompanies(nextProps)
    }
  }

  _findCompanies = (props) => {
    const query = _get(props, ['location', 'query']) || {}
    this.props.attemptFindCompanies(_omitBy({
      offset: (parseInt(query.page || 1, 10) - 1) * 100,
      companyCode: query.keyword,
      companyName: query.keyword
    }, _isNil))
  }

  _onSearch = (keyword) =>
    this.context.router.replace(`${this.props.location.pathname}?keyword=${keyword}`)

  _renderRow = ({ companyCode, companyName }, index) => (
    <tr key={companyCode}>
      <td className='text-center'>{index + 1}</td>
      <td className='text-center'>{companyCode}</td>
      <td style={{ textIndent: 10 }}>{companyName}</td>
    </tr>
  )

  _renderMobileRow = ({ companyCode, companyName }, index) =>
    <div key={companyCode} className='row'>
      <div className='line'>
        <strong>ลำดับ</strong>
        <span>{index + 1}</span>
      </div>
      <div className='line'>
        <strong>รหัส</strong>
        <span>{companyCode || '-'}</span>
      </div>
      <div className='line'>
        <strong>ชื่อบริษัท</strong>
        <span>{companyName}</span>
      </div>
    </div>

  render () {
    const { location, companies, pageCount } = this.props
    return (
      <section className={classes.companies}>
        <Heading>ค้นหาบริษัทผู้จัดจำหน่าย</Heading>
        <div className={classes.searchContainer}>
          <Searchbox keyword={_get(location, ['query', 'keyword'])} onSearch={this._onSearch}
            description='ค้นหาบริษัทได้จาก รหัสบริษัท, ชื่อบริษัทผู้จัดจำหน่าย' />
        </div>
        <Pagination router={this.context.router} location={location} pageCount={pageCount} />
        <table className='with-stripe desktop'>
          <thead>
            <tr>
              <th>ลำดับ</th>
              <th>รหัส</th>
              <th>ชื่อบริษัทผู้จัดจำหน่าย</th>
            </tr>
          </thead>
          <tbody>{companies.map(this._renderRow)}</tbody>
          {!companies.length && <tr><td className='text-center' colSpan='8'>ยังไม่มีรายชื่อบริษัท</td></tr>}
        </table>
        <section className='list'>
          {companies.map(this._renderMobileRow)}
        </section>
        <Pagination router={this.context.router} location={location} pageCount={pageCount} />
      </section>
    )
  }
}

export default AdminCompanies



// WEBPACK FOOTER //
// ./src/containers/Admin/AdminCompany/AdminCompanies.js